import { inject, Injectable } from '@angular/core';
import type {
    CorrelationModel,
    CorrelationType,
    MarketChartCorrelation, TimeFrame, TimeSeriesIdentifierInput
} from '@clean-code/models';
import type { Observable } from 'rxjs';
import { MarketDataWidgetService } from '../infrastructure/market-data-widget.data.service';

@Injectable({ providedIn: 'root' })
export class CorrelationWidgetFacade {
  private service = inject(MarketDataWidgetService);

  public marketTableCorrelation$(
    symbols: TimeSeriesIdentifierInput[],
    timeFrame: TimeFrame,
    weeks: boolean,
    months: boolean,
    years: boolean,
  ): Observable<CorrelationModel[]> {
    return this.service.marketTableCorrelation$(
      symbols,
      timeFrame,
      weeks,
      months,
      years,
    );
  }

  marketChartCorrelation$(
    baseDataSource: TimeSeriesIdentifierInput,
    symbols: TimeSeriesIdentifierInput[],
    timeFrame: TimeFrame,
    type: CorrelationType,
  ): Observable<MarketChartCorrelation[]> {
    return this.service.marketChartCorrelation$(
      baseDataSource,
      symbols,
      timeFrame,
      type,
    );
  }
}
